/**
 * VAL-ACTOR-JOURNEY-1-SIGNER slice C, R4 — split out of ValuationIntake.tsx
 * under docs/FILE_SIZE_POLICY.md. Visible whenever `fields` is non-empty;
 * each item scrolls to its field.
 */
export interface MissingField {
  id: string
  label: string
}

export function IntakeMissingFields({ fields }: { fields: MissingField[] }) {
  if (fields.length === 0) return null

  function scrollToField(id: string) {
    const el = document.getElementById(id)
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el?.focus()
  }

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
      <p className="font-medium">Before you can run this valuation, fill in:</p>
      <ul className="mt-2 list-inside list-disc space-y-1">
        {fields.map(f => (
          <li key={f.id}>
            <button
              type="button"
              onClick={() => scrollToField(f.id)}
              className="underline underline-offset-2 hover:text-amber-700"
            >
              {f.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
